import styled from "styled-components/macro";

export const OverlayText = styled.div`
  position: absolute;
  z-index: 1;
  color: white;
  display: flex;
  justify-content: space-around;
  align-items: ${({ delay }) => (delay ? "flex-end" : "flex-start")};
  width: 100%;
  height: 90%;
  font-size: 0.7rem;
`;

export const LandScapeContainer = styled.div`
  width: 134.5%;
  height: 67.75%;
  transform: rotate(90deg);
  position: absolute;
  left: -12%;
  bottom: 16%;
  background: black;
  /* opacity: .2; */

  /* width: 100%;
  height: 100%;
  transform: rotate(90deg);
  position: absolute;
  left: -15%;
  bottom: 11%;
  background: black; */
`;

export const WaveContainer = styled.div`
  padding-top: 1em;
  padding-bottom: 1em;
  display: grid;
  height: 50%;
  grid-template-areas:
    "vwave1"
    "vwave2";
  grid-template-columns: 1fr;
  grid-template-rows: 50% 50%;
  background: black;
`;

export const BlackBox = styled.div`
  position: absolute;
  top: 29%;
  height: 71.3%;
  width: 100.4%;
  background: black;
`;

export const Landscapeflex = styled.div`
  display: grid;
  grid-template-areas: "box1 box2 box3";
  grid-template-columns: 1fr 1fr 1fr;
`;

export const Landscapeflex2 = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 60px;
  width: auto;
`;

export const NumericOverlay = styled.div`
  position: absolute;
  background: orange;
  width: 100%;
  height: 19%;
  top: 29%;
  opacity: 0;
`;
export const ColumnWaves = styled.div`
  display: flex;
  flex-direction: column;
  overflow: visible;

  height: ${({ multilead }) => (multilead ? "55%" : "50%")};

  overflow: hidden;
  width: 100%;
  /* height: 60%; */
  background: var(--clr-settingsbg);
  background: black;

  display: flex;
  flex-direction: column;
  margin-top: 0.2em;

  gap: 0.5em;
`;

export const ImgWaveBox = styled.div`
  /* padding-bottom: 0.1em; */
  background: black;
  width: ${({ full }) => (full ? "400px" : "380px")};
  /* max-height: 60px; */
  /* height: 25%; */
  height: 100%;
  position: relative;
  /* display: grid;
  grid-template-columns: .9fr;
  grid-template-rows: 45px 45px; */
  max-height: 50px;
`;

export const WaveImgLandscape = styled.img`
  opacity: ${({ ecgOff }) => (ecgOff ? "0" : "1")};
`;

export const WaveVidLandscape = styled.video`
  opacity: ${({ ecgOff }) => (ecgOff ? "0" : "1")};
  object-fit: fill;
`;

export const VideoPlayerContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  opacity: 0.15;
`;

export const WaveBox = styled.div`
  overflow: hidden;
  width: 100%;
  background: var(--clr-settingsbg);
  display: flex;
  flex-direction: column;
  margin-top: 0.2em;

  & img {
    display: flex;
    width: 100%;
  }
`;

export const ScrollBox = styled.div`
  overflow-y: visible;
  overscroll-behavior: unset;

  overflow-x: hidden;
  width: 100.2%;
  background: var(--clr-settingsbg);
  display: flex;
  flex-direction: column;

  & video {
    width: 101%;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    z-index: 1000;
    background: var(--clr-settingsbg);
  }

  ::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: #000;
  }
`;

export const ScrollBoxTest = styled.div`
  height: 200px;
`;
